import { useState } from "react";

import { IPageable, IPageMeta, TPageableFetchFunction } from "../types";
import { useMetaPageableFetcher } from "./useMetaPageableFetcher";

/**
 * Accept async pageable fetch function that will be handled in effect
 *
 * @template R Return type
 * @template M Response meta type
 * @template F Filter config type
 * @template S Sort config type
 * @param {TPageableFetchFunction<R, M>} fetchFunction function that handle pageable fetch
 * @param {any[]} deps hook deps
 * @returns {State<R, M>}
 */
export const usePageableFetcher = <R, M extends IPageable<R[]>, F, S>(
  fetchFunction: TPageableFetchFunction<R, M, F, S>,
  deps: any[] = [],
) => {
  const [meta, changeMeta] = useState<IPageMeta<F, S>>({
    page: 0,
    size: 20,
  });

  const pageableFetcher = useMetaPageableFetcher(fetchFunction, { meta, changeMeta }, [meta, changeMeta, ...deps]);

  return {
    ...meta,
    ...pageableFetcher,
  };
};
